import { render, staticRenderFns } from "./IconLogoBase64.vue?vue&type=template&id=310ec86e&scoped=true"
import script from "./IconLogoBase64.vue?vue&type=script&lang=js"
export * from "./IconLogoBase64.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310ec86e",
  null
  
)

export default component.exports